



const PageLoader = ({width = "3rem"}) => {
    return (<div className="d-flex justify-content-center align-items-center" style={{
        position: "absolute",
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        zIndex: 999,
    }}>
        <div className="spinner-border text-primary" style={{ width, height: width }} role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    </div>);


}

export default PageLoader;